import { useCallback } from 'react'

import { HasNestedString } from './generalTableHelpers'
import { useColumnCustomSearchFilter } from './useColumnCustomSearchFilter'

/**
 * client-side Ant Table columns filter by nested dataIndexes
 */
export function useNestedColumnSearchFilter<T>() {
  const { getCustomSearchFilter } = useColumnCustomSearchFilter<T>()

  const getNestedSearchFilter = useCallback(
    <K extends string, N extends string>(
      parentIndex: K,
      childIndex: N,
      placeholder?: string
    ) => {
      const onFilter = (value: string, record: T) => {
        const searchValue = value.toLowerCase()
        const nestedRecord = record as T & HasNestedString<K, N>
        const columnValue =
          nestedRecord[parentIndex]?.[childIndex]?.toString().toLowerCase() ||
          ''
        return columnValue.includes(searchValue)
      }
      return getCustomSearchFilter(onFilter, placeholder)
    },
    [getCustomSearchFilter]
  )

  return { getNestedSearchFilter }
}
